import React from 'react';
import TaskCard from './TaskCard';
import { tasks } from './tasksData';
import './DailyView.css';
import { useState } from 'react';
import surahList from './surahList';
import Select from 'react-select';
import { addSurah, getSurah } from '../../actions/appAction';
import { useDispatch } from 'react-redux';
import surasData from '../suraData';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import StatisticsView from '../../components/StatisticsView';
import BottomBar from '../../components/BottomBar';
import fireIcon from '../../assets/icon/fire.svg';
import { getStreakData } from '../../utils/streak';

const DailyView = () => {
  const dispatch = useDispatch();
  const [dailyPages, setDailyPages] = useState(1);
  const [selectedSurah, setSelectedSurah] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [allReview, setAllReview] = useState([]);
  const {review, error} = useSelector(state => state.app);
  const today = new Date().toISOString().slice(0, 10);
  const [localError, setLocalError] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [streak, setStreak] = useState(getStreakData().count);
  useEffect(() => {
    const { count, lastDate } = getStreakData();
    if (lastDate) {
      const todayDate = new Date();
      const last = new Date(lastDate);
      last.setHours(0, 0, 0, 0);
      todayDate.setHours(0, 0, 0, 0);
      const diff = Math.floor((todayDate - last) / (1000 * 60 * 60 * 24));
      if (diff >= 2) {
        localStorage.setItem('streakCount', '0');
        localStorage.setItem('streakDate', todayDate.toISOString().slice(0, 10));
        setStreak(0);
      } else {
        setStreak(count);
      }
    }
  }, []);


  useEffect(() => {
    if (feedback) {
      const t = setTimeout(() => setFeedback(null), 7000);
      return () => clearTimeout(t);
    }
  }, [feedback]);

  useEffect(() => {
    dispatch(getSurah());
  }, [dispatch]);
  useEffect(() => {
    if (error?.error === "Surah already exists in memorization.") {
      setLocalError("السورة موجودة بالفعل في قائمة الحفظ.");
    } else if (!error) {
      setLocalError(null);
    }
  }, [error]);
  
  const handleSurahSelect = (selectedSurah) => {
    setSelectedSurah(selectedSurah);
    console.log("Selected Surah:", selectedSurah);
  }
  const handleOpenPopup = () => {
    setShowPopup(true);
  }
  const handleClosePopup = () => {
    setShowPopup(false);
    setLocalError(null);

  }

  const handelSendDataBtn = async () => {
    if (!selectedSurah) {
      setFeedback({ type: 'error', message: 'يرجى اختيار سورة' });
      return;
    }
    const data = {
      surah_id: selectedSurah.value,
      memorize_level: dailyPages
    };
    // if (!data.surah_id) {
    //   alert('يرجى اختيار سورة');
    //   return;
    // }
    try {
      // this will throw if you use .unwrap()
      // await dispatch(addSurah(data));
      const res = await dispatch(addSurah(data));
      if (res) {
        setFeedback({ type: 'success', message: res.message || 'تمت العملية بنجاح' });
      }

      dispatch(getSurah());
      setShowPopup(false);
      setSelectedSurah(null);
      setLocalError(null);
    } catch (err) {
      setLocalError(err.message || 'حدث خطأ');
      setFeedback({ type: 'error', message: err.message || 'حدث خطأ أثناء إضافة السورة' });
    }
  }
  const [memorizationData, setMemorizationData] = useState([]);
  const [reviewData, setReviewData] = useState([]);
  const todayformat = `"${today}"`;
  const addMemorizationData = () => {
    try {
      const memorizationData = review.memorize_data
      console.log("Memorization data:", memorizationData);
      setMemorizationData(memorizationData);
      console.log("Memorization data:", memorizationData);
    } catch (error) {
      console.error("Error filtering memorization data:", error);
    }
  }
  const addReviewData = (data) => {
    try {
      // const reviewData = review.review_data.filter(item => item.review_status === true);
      const reviewData = review.review_data
      setReviewData(reviewData);
      console.log("Review data:", reviewData);
    } catch (error) {
      console.error("Error filtering review data:", error);
    }
  }
  useEffect(() => {
    addMemorizationData();
    addReviewData();
  }, [review]);


  console.log("ERROR from Redux:", error);
  return (
    <div className="daily-container">
            {feedback && (
        <div
          className={`feedback-popup ${
            feedback.type === 'success' ? 'success' : 'error'
          }`}
        >
          {feedback.message}
        </div>
      )}
      {/* Header */}
      <div className="daily-header">
        <h1 className="daily-title">ترسيخ</h1>
        <div className="streak">
          <span>{streak}</span>
          <img src={fireIcon} alt="streak" className="streak-icon" />
        </div>
      </div>

      {/* Cards */}
      <div className="cards-wrapper">
        {/* Statistics box */}
        <StatisticsView />

      {/* Memorization box */}
        <TaskCard 
          title="حفظ اليوم:"
          items={memorizationData}
          type={false}
          click={handleOpenPopup}
        />

        {/* Review box */}
        <TaskCard 
          title="مراجعة اليوم:"
          items={reviewData}
        />

      </div>
      {showPopup && (
        <div className='overlay'>

          <div className='popup-container'>
            <div className='popup'>
              <div className='popup-header'>
              <button className='close-button' onClick={handleClosePopup}>X</button>
              <h3>اضافة حفظ جديد</h3>
              </div>
              <div className='popup-content'>
              <div className='choose-surah-container'>
                {/* {localError  && <p className="error-message">{localError}</p>} */}
                {localError && (
                    <div className="feedback-popup error">{localError}</div>
                  )}
                  <h3>اختر السورة</h3>
                  <Select
                    className='surah-select'
                    options={surahList}
                    value={selectedSurah}
                    onChange={handleSurahSelect}
                    isSearchable={true}
                    placeholder='ابحث عن سورة...'
                  />
                </div>
                <div className='choose-amount-container'>
                  <h3>مقدار الحفظ اليومي:</h3>
                  <div className="daily-memorize-section">
                    <div className="daily-options">
                      <label>
                        <input
                          type="radio"
                          name="dailyPages"
                          value="1"
                          checked={dailyPages === 1}
                          onChange={() => setDailyPages(1)}
                        />
                        <span>نصف صفحة</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="dailyPages"
                          value="2"
                          checked={dailyPages === 2}
                          onChange={() => setDailyPages(2)}
                        />
                        <span>صفحة</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="dailyPages"
                          value="1.5"
                          checked={dailyPages === 3}
                          onChange={() => setDailyPages(3)}
                        />
                        <span>صفحة ونصف</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="dailyPages"
                          value="2"
                          checked={dailyPages === 4}
                          onChange={() => setDailyPages(4)}
                        />
                        <span>صفحتان</span>
                      </label>
                    </div>
                  </div>
                  <div className='send-button-container'>
                    <button className='send-button' onClick={handelSendDataBtn}>اضافة</button>
                  </div>

              </div>
            </div>
            </div>
          </div>
        </div>

      )}
      <BottomBar />
    </div>
  )
};

export default DailyView;
